export default {
    'accessibility': {
        'navigation': {
            'header': 'header',
            'mainMenu': 'navigation',
            'moreMenu': 'more options',
            'mobileMenu': 'mobile navigation',
            'openMobileMenuButton': 'open mobile navigation menu',
            'closeMobileMenuButton': 'close mobile navigation menu',
            'userMenu': 'user menu',
            'current': 'selected',
        }
    },
    'update': {
        'dialog': {
            'title': 'New version available',
            'content': 'When activated, the Meter Reading Portal reloads briefly. Readings you have already submitted are kept.',
            'buttonNegative': 'Later',
            'buttonPositive': 'Activate now'
        }
    },
    'login': {
        'title': 'Welcome to {{applicationName}}',
        'subtitle': 'Please log in with the login details you received from us:',
        'qrcode': {
            'error': {
                'access': {
                    'dialogtitle': 'Camera access not possible',
                    'title': 'We couldn\'t open your camera.',
                    'text': 'Please use your login details to proceed',
                },
                'device': {
                    'title': 'You can\'t use the QR code login with your device - or you didn\'t grant access to your camera.',
                },
            },
            'teaser': {
                'text': 'Have you received a QR code on a reading card or in a letter? And do you have a webcam?<1/> Then just scan the QR code. We will log you in quickly:',
                'access': 'To log in with the QR code, we need access to your camera.',
            },
            'dialog': {
                'hint': 'Hold the QR code from your letter or reading card inside the frame.',
                'searching': 'Looking for a QR code …',
                'checking': 'Checking your sign-in …',
                'invalid': 'This QR code is invalid or has expired.',
                'foreign': 'This QR code does not belong to the meter reading.',
                'alternative': 'Sign in with my access data instead',
            },
            'buttons': {
                'login': 'Sign in with a QR code',
                'close': 'Close',
            },
        },
        'labels': {
            'username': 'Username',
            'password': 'Password',
            'qr-login': 'QR-Code Login',
        },
        'placeholders': {
            'username': 'My Username',
            'password': 'Password',
        },
        'buttons': {
            'login': 'Login',
        },
        'tabs': {
            'login': 'Login with Login Details',
            'unknownUserReading': 'Reading without Login Details'
        },
        'error': {
            'login': {
                'text': 'Login failed. Please check your entered data.',
            },
            'dialog': {
                'title': 'Login failed',
                'description': 'We are sorry, the login with these credentials is currently not possible',
                'content': 'If you received a reading card, perhaps it\'s not yet synced.<1 /><2 />Please try again later!',
                'buttons': {
                    'close': 'Close',
                    'unknownUserReading': 'Meterreading without login'
                },
                'unknownUserReading': 'Alternatively, you can submit your meter reading here without logging in:',
            },
        },
        'usage': {
            'text': 'This page is being provided by {{applicationName}}. By login and using, you declare that you agree to our <3>data privacy terms</3>.',
        },
    },
    'unknownUserReading': {
        'loginScreen': {
            'text': 'You want to send your meter reading but did not receive a letter?',
            'buttonText': 'Meter Reading without Login'
        },
        'doneScreen': {
            'title': 'Your meter reading is complete',
            'message': 'Thank you! Your meter reading has been successfully transmitted.'
        },
        'screenTitle': 'Submit meter reading',
        'errorHandling': {
            'isAuthPending':'You are being logged in, please wait.',
            'isAuthError': 'Error logging in. Please try again later.',
            'tokenExpired': 'Your session has expired, please log in again.',
            'featureNotAvailable': 'Reading without Login Details is currently not possible. Please try again later.',
        },
        'introduction': {
            // 'title': 'Your meter reading',
            'screenHint': 'You can also tell us your meter reading without login',
            'pinReceivedHint': 'If you have received access data by letter or a meter reading card from our meter reader, please register here:'
        },
        'meterStep': {
            'title': 'Meter selection',
            'description': 'Please first enter your meter number and select the type of meter you have.',
            'validationError': 'Please enter the meter number in full.',
        },
        'meterReadingStep': {
            'title': 'Meter reading',
            'description': 'Please now enter the meter readings of your meter {{preposition}} decimal places.',
            'validationError': 'Please enter the meter readings in full.',
        },
        'contactStep': {
            'title': 'Contact details',
            'description': 'So that we can assign your details correctly, we need your contact details and the address of the meter.',
            'validationError': 'Please fill in all required fields (*).',
            'meterReadingZIPCodeValidation': {
                'title': 'Meter reading not possible',
                'content': 'This meter is not in our area. That is why we cannot accept the meter reading. Please report the reading directly to your responsible metering point operator. Thank you for your understanding!',
            },
        },
        'summaryStep': {
            'title': 'Summary',
            'description': 'Please check your entries before submitting the data'
        },
        'information': {
            'meterNumberHint': 'We need the complete meter number to correctly assign your meter reading.',
            'emailProcessing': 'Note: The use of the e-mail function is voluntary. The e-mail address will not be stored permanently without your consent.',
            'privacyPolicy': 'This page is being provided by {{applicationName}}. I have taken note of the <3>data protection information</3> in accordance with Art. 13 and 14 GDPR.',
        },
        'notification': {
            'readingRequest': {
                'error': {
                    'title': 'Transmission failed',
                    'description': 'The meter reading could not be transmitted. Please try again later.',
                },
                'success': {
                    'title': 'Meter reading transmitted',
                    'description': 'The meter reading was successfully transmitted.',
                }
            },
            'readingReceipt': {
                'error': {
                    'title': 'Copy via e-mail failed',
                    'description': 'A copy of your meter readings could not be sent to the e-mail address you provided.',
                },
                'success': {
                    'title': 'Copy sent via e-mail',
                    'description': 'A copy of your meter readings has been sent to the e-mail address you provided.',
                }
            }
        },
        'subTitle': {
            'meterNumber': 'Meternumber',
            'meterType': 'Metertype',
            'meterSubType': 'Subtype',
            'meterReading': 'Reading results',
            'readingDate': 'Reading date',
            'contact': 'Your contact details',
            'meterAddress': 'Meter address',
            'readingReason': 'Reading reason',
            'meter': 'Your meter',
            'readingValues': 'Reading values',
            'email': 'Would you like a copy of your meter readings by e-mail?',
            'privacyPolicy': 'Privacy policy',
        },
        'description': {
            'readingDate': 'When did you record the meter reading?',
            'dataPrivacyRequired': 'Please agree to the privacy policy. Only then can we save your data.',
        },
        'label': {
            'meterNumber': 'Meternumber',
            'meterType': 'Metertype',
            'meterSubType': 'Subtype',
            'queryTransformerOrMWhPostDecimals': 'Record decimal places for transformer or MWh metering',
            'contact': 'Contact information',
            'firstname': 'Firstname',
            'lastname': 'Lastname',
            'meterAddress': 'Meter address',
            'street': 'Street',
            'houseNumber': 'House Number',
            'zip': 'ZIP',
            'city': 'City',
            'readingReason': 'Reading reason',
            'readingDate': 'Reading date',
            'email': 'E-Mail'

        },
        'placeholder': {
            'meterNumber': 'Meternumber',
            'firstname': 'Firstname',
            'lastname': 'Lastname',
            'street': 'Street',
            'houseNumber': 'House Number',
            'zip': 'ZIP',
            'city': 'City',
            'email': 'E-Mail',
        },
        'meterType': {
            'ELECTRIC_METER': 'Electric Meter',
            'HEAT_METER': 'Heat Meter',
            'GAS_METER': 'Gas Meter',
            'WATER_METER': 'Water Meter',
            'WATER_WARM_METER': 'Warm Water Meter',
        },
        'meterSubType': {
            'ELECTRIC_METER_TARIFFS_ONE': 'Electric Meter (1 Tariff)',
            'ELECTRIC_METER_TARIFFS_TWO': 'Electric Meter (2 Tariffs)',
            'ELECTRIC_METER_FEED_IN_METER': 'Electric Meter (Feed-In)',
            'OTHER': 'other'
        },
        'readingReason': {
            'ANNUAL_READING': 'Annual reading',
            'CONTROL_READING': 'Control reading',
            'PROVIDER_CHANGE': 'Change of provider / relocation',
        },
        'rateName': {
            'Verbrauch': 'Consumption',
            'Einspeisung': 'Feed-In',
        },
        'button': {
            'refreshToken': 'Log in',
            'toHome': 'Back to home',
            'removeMeterRate': 'Remove tariff',
            'loginWithPIN': 'Log in with access data',
            'forceContinue': 'Submit anyway',
            'continue': 'Continue',
            'submit': 'Submit'
        },
        'preposition': {
            'with': 'with',
            'without': 'without'
        }
    },
    'home': {
        'title': 'My Meter Reading Portal - {{applicationName}}',
        'introduction': {
            'title': 'Welcome',
            'reading': 'Find your meters in the menu <1>$t(menu.reading)</1>. There you can enter and send your meter readings quickly and easily.',
            'management': 'To share readings, click on <1>$t(menu.management)</1>. As a property manager, you share e.g. your readings with your property manager or the caretakers.',
        },
        'account': {
            'title': 'My Account',
            'title_other': 'My Accounts',
            'multipleAccounts': 'You have registered with several accounts:',
            'login': {
                'info': 'You are logged in as <1>{{name}}</1>.',
                'parent': 'This Account was created by <1>{{parent}}</1>.',
                'shared': 'shared by {{parent}}',
            },
        },
        'readings': {
            'title': 'My Readings',
            'open': 'You have <1>{{jobCountOpen}} pending</1> meter reading.',
            'open_other': 'You have <1>{{jobCountOpen}} pending</1> meter readings.',
            'done': 'All your meter readings are done!',
            'labels': {
                'totalReadings': 'total readings',
                'progress': 'progress (done)',
            },
            'buttons': {
                'openReadings': 'Open $t(common.reading_other)',
                'aiReading': 'Start reading assistant',
            },
        },
    },
    'jobs': {
        'search': {
            'noResults': 'We found nothing for <1/> <3>{{searchValue}}</3> <5/>.',
        },
        'labels': {
            'readingsDone': 'done',
        },
        'share': {
            'assignmentPresets': {
                'saveCheckbox': 'Save this selection as a preset',
                'modeNew': 'Create new preset',
                'modeOverwrite': 'Overwrite existing preset',
                'nameLabel': 'Preset name',
                'selectExisting': 'Choose preset',
                'emailLabel': 'Email addresses for the preset (optional)',
                'nameConflict': 'A preset with this name already exists.',
            },
            'title': 'Share Reading Jobs',
            'placeholders': {
                'name': 'Property Management Doe',
                'email': 'john@example.com',
            },
            'descriptions': {
                'accessName': 'Give the new access a name. You will see this name later in your overview – together with the progress of the reading. The new access can also see this name.',
                'reshareAllowed': 'If you turn this on, this access may pass the meters on to other people. If the access reads the meters itself, you do not need this.',
            },
            'defaultShareName': 'Reading Job {{meterNumber}}',
            'defaultShareName_other': 'Reading Job {{meterNumber}} et al.',
            'labels': {
                'accessName': 'Access Name',
                'additionalOptions': 'Additional Options',
                'reshareAllowed': 'reshare allowed',
                'accessEmail': 'E-Mails of Access',
                'username': 'Username',
                'password': 'Password',
                'tokenLogin': 'Direct-Link',
                'webLogin': 'Web-Portal-URL',
                'qrcode': 'QR Code',
            },
            'sending': 'Sharing Reading Jobs...',
            'success': {
                'summary': 'The access "{{name}}" was created successfully and contains {{count}} meter.',
                'summary_other': 'The access "{{name}}" was created successfully and contains {{count}} meters.',
                'message': 'You can now share the following login data for this access.',
                'loginMethod': {
                    'email': {
                        'title': 'Send access data via E-Mail',
                        'description':
                            'You can send the login data directly to the e-mail addresses of the access.',
                        'notifications': {
                            'valid': 'The emails you selected are valid.',
                            'warning': 'The emails you selected are not valid!',
                        },
                        'send' : 'The login has been sent to {{email}}.'
                    },
                    'triggerText': 'Show optional login options',
                    'direct': {
                        'title': 'Direct login via link',
                        'description': 'The provided link already contains the login data.'
                    },
                    'web': {
                        'title': 'Manual login',
                        'description': 'Sharing the manual login allows the login via username and password.',
                    },
                },
            },
            'buttons': {
                'createAccess': 'Create Access',
                'copyTokenUrl': 'Copy Token-URL',
                'send': 'Send',
                'close': 'Close',
            },
        },
        'details': {
            'meloAttribute': {
                'sectionAria': 'Additional information for the meter or metering point',
                'sectionTitle': 'My Notes',
                'addAria': 'Add note',
                'addLabel': 'Note',
                'editAria': 'Edit note',
                'valueLabel': 'Note',
                'save': 'Save',
                'cancel': 'Cancel',
                'delete': 'Delete',
                'dialog': {
                    'addTitle': 'Add note',
                    'editTitle': 'Edit note',
                    'description': 'This personal note is saved for the meter or metering point and will be available to you again at your next meter reading.',
                },
                'deleteConfirm': {
                    'title': 'Delete note',
                    'content': 'Do you really want to delete this note?',
                    'ok': 'Delete',
                    'cancel': 'Cancel',
                },
                'errors': {
                    'conflict': 'The note could not be saved (e.g. maximum reached, or not possible for this meter or metering point).',
                    'stale': 'The note was changed in the meantime. Please reload the page to see the latest version.',
                    'generic': 'The note could not be saved. Please try again.',
                },
                'keys': {
                    'NOTE': 'Note',
                },
            },
            'title': 'Meter Reading Job',
            'successTitle': 'Reading successfully submitted',
            'successDescriptionOtherJobs': 'You can now continue with your other meter readings.',
            'successDescriptionAllDone': 'You have successfully read all meters.',
            'successDescriptionThankYou': 'Thank you!',
            'pendingSuccessTitle': 'Reading captured – will send once online',
            'pendingSuccessHint': 'You are currently offline. Your reading has been captured and will be sent automatically as soon as an internet connection is available again. Please stay in the Meter Reading Portal in the meantime.',
            'pendingSuccessHintOtherJobs': 'In the meantime, you can read more meters.',
            'doneHint': '<0>This meter has already been read.</0><1/> You can correct the meter reading and send us a new reading.',
            'doneHintLate': '<0>This meter has already been read.</0><1/> You can correct the meter reading and send us a new reading.',
            'doneHintOverdue': '<0>This meter has already been read.</0><1/> You can correct the meter reading and send us a new reading.',
            'sending': 'Sending data...',
            'multiObisWarning': 'This meter has <1 className=\'font-medium\'>{{meterRateCount}} tariffs</1>: Please enter each value for the correct tariff!',
            'send': {
                'confirm': 'Send anyway',
                'cancel': 'Correct values',
            },
            'unsavedChanges': {
                'title': 'Discard entries?',
                'content': 'Your entries have not been submitted yet. If you leave this page now, the entered data will be lost.',
                'confirm': 'Discard entries',
                'cancel': 'Keep editing',
            },
            'labels': {
                'meterNumber': '$t(meterReadingJob.meterNumber)',
                'maLoId': '$t(meterReadingJob.maLoId)',
                'meterType': 'Metertype',
                'customer': '$t(meterReadingJob.customer.title)',
                'customerNumber': '$t(meterReadingJob.customer.customernumber)',
                'deliveryPoint': 'Address',
                'readingValue': 'Reading Value',
                'reading': 'Meter Reading',
                'readingImage': 'Reading Photo',
                'obis': 'Rate',
                'partner': 'Contract Partner',
                'objectKey': 'Object',
                'locationDescription': 'Location',
                'hint': 'Hint',
                'readingDate': 'Reading Date',
                'readingHint': 'Reading Hint',
                'targetReadingDate': '$t(common.targetReadingDate)',
                'meterRateTaskReadingImages': 'Reading Photos',
                'meterRateTaskReadingComment': 'Reading Hint',
                'aiReading': 'Reading assistant',
            },
            'readingHint': {
                'placeholder': 'No hint',
                'meterChanged': 'Meter was changed',
                'freetext': {
                    'label': 'other hint',
                    'placeholder': 'Hint for the reading...',
                },
            },
            'warnings': {
                'constraints': {
                    'beforeEarliestExecution': {
                        'title': 'The reading period has not yet started',
                        'description': 'We requested the meter reading from <1>{{earliestExecution}}</1>.<br/> You can still read the meter. But we may estimate your consumption.',
                    },
                    'afterLatestExecution': {
                        'title': 'The reading period has expired',
                        'description': 'We requested the meter reading until <1>{{latestExecution}}</1>.<br/> You can still read the meter. But we may no longer be able to use the reading for billing.',
                    },
                    'beforeSendingReadingValuesIsAllowedBasedOnEarliestExecutionAndDuration': {
                        'title': 'The reading period has not yet started',
                        'description': 'You can only send the meter reading from <1>{{earliestExecution}}</1>.<br/> If you have any questions, please contact customer service.'
                    },
                    'afterSendingReadingValuesIsAllowedBasedOnLatestExecutionAndDuration': {
                        'title': 'The reading period has expired',
                        'description': 'You can no longer send the meter reading. The reading period is over.<br/> If you have any questions, please contact customer service.'
                    }
                },
                'check': {
                    'title': 'Please check the values',
                    'message': 'Please check the values again.',
                    'details': 'Please check: Did you read the correct number of decimal places? And did you not accidentally move the decimal point?',
                },
                'incomplete': {
                    'title': 'Incomplete values',
                    'message': 'Your meter has several rates. But you only entered values for some of them.',
                    'details': 'For correct billing, your provider usually needs all meter readings. If a reading is missing, it is often estimated.',
                },
                'invalidText': 'Please enter exactly {{count}} decimal place.',
                'invalidText_other': 'Please enter exactly {{count}} decimal places.',
                'validationWarningText': 'The meter reading is not plausible, please check your entry.',
                'historicValidationWarningText': 'The meter reading is not plausible, the value is lower than the last reading.',
                 // fixme: is not processed | 'historicValidationErrorText': 'The meter reading is not plausible, the value is lower than the last reading. Please add a reading photo or a reading hint.',
                'historicValidationFeedInMeterWarningText': 'The meter reading is not plausible, the value is lower than the last reading.',
                'continuousReadingsValidationWarningText': 'The meter reading is not plausible, the value is lower than the last reading.',
                'continuousValidationImageRequiredError': 'The meter reading is lower than the previously submitted value. Please add a reading photo.',
                'continuousValidationImageOrCommentRequiredError': 'The meter reading is lower than the previously submitted value. Please add a reading photo or a reading hint.',
                'imageRequiredError': 'The meter reading is not plausible. Please add a reading photo.',
                'imageOrCommentRequiredError': 'The meter reading is not plausible. Please add a reading photo or a reading hint.',
                // fixme: is not processed | 'imageAndCommentRequiredError': 'The meter reading is not plausible. Please add a reading photo and a reading hint.',
                'imageRequiredFeedInMeterError': 'The meter reading is not plausible. Please add a reading photo.',
                'imageOrCommentRequiredFeedInMeterError': 'The meter reading is not plausible. Please add a reading photo or a reading hint.',
                // fixme: is not processed | 'imageAndCommentRequiredFeedInMeterError': 'The meter reading is not plausible. Please add a reading photo and a reading hint.',
                'hintRequiredError': 'A meter reading is not plausible. Please enter a reading hint.',
                'hintMinLengthWarning': 'The reading hint should contain at least 5 characters.',
                'imageAlwaysRequiredHint': 'Please add a photo of your meter reading to send your results.',
                'imageAlwaysRequiredHint_other': 'Please add photos of your meter readings to send your results.'
            },
            'plausibilityHints': {
                'readingValueGreaterThanMaximumValue': 'Reading higher than expected',
                'readingValueLessThanMinimumValue': 'Reading lower than expected',
            },
            'tooltips': {
                'readingValueGreaterThanMaximumValue' : 'The reading value is greater than expected.',
                'readingValueLessThanMinimumValue' : 'The reading value is smaller than expected.',
            },
            'imageUploaded': 'Reading photo added',
            'notifications': {
                'imageFormatUnsupported': {
                    'title': 'Photo could not be added',
                    'message': 'The selected file format is not supported. Please select another photo.',
                },
            },
            'dialogs': {
                'meterRateTaskReadingImages': {
                    'title': 'Reading photos',
                    'closeButton': 'Close',
                }
            },
            'confirmRemoveImage': {
                'title': 'Remove reading photo?',
                'content': 'The photo will be removed and cannot be restored.',
                'ok': 'Remove',
            },
            'buttons': {
                'uploadImage': 'Add reading photo',
                'dropImage': 'Drop reading photo here',
                'selectImageFromGallery': 'Select reading photo from gallery',
                'removeImage': 'Remove reading photo',
                'send': 'Send',
                'share': 'Share',
                'more': 'More actions',
                'resendMeterReading' : 'Resubmit Meter Reading',
                'resendMeterReading_other' : 'Resubmit Meter Readings',
            },
            'capturedValues': {
                'title': 'Contact details',
                'description': 'For queries about the reading. Providing them is optional.',
                'descriptionRequired': 'For queries about the reading.',
                'labels': {
                    'phone': 'Phone number',
                    'phoneRegion': 'Country of the phone number',
                    'otherRegion': 'Other',
                    'email': 'Email address',
                },
                'placeholders': {
                    'phone': 'e.g. 0123 456789',
                    'phoneInternational': 'e.g. +49 123 456789',
                    'email': 'e.g. name@example.com',
                },
                'warnings': {
                    'phoneInvalid': 'This phone number is invalid. Please check your entry.',
                    'phoneCountryCodeMissing': 'Please start with the country code, e.g. +49 or 0049.',
                    'phoneRequired': 'Please enter a phone number.',
                    'emailInvalid': 'This email address is invalid.',
                    'emailRequired': 'Please enter an email address.',
                },
            },
        },
        'home': {
            'title': 'Overview: Meter Readings',
            'expireWarning': '<0>Attention</0> on {{expireDate}} {{expireCount}} jobs will expire, that are not yet done!',
            'statistic': {
                'title': '$t(common.reading_other)',
                'total': 'total',
                'done': 'done',
            },
            'period': {
                'title': 'Reading Periods',
                'description': 'For your bill to be created correctly, the meter readings must be sent to us in good time. Here you can see the periods until when we need your meter reading:',
                'showMeters': 'Show meters',
            },
        },
        'unknownMeterReading': {
            'listItemLabel': 'record another meter reading',
            'heading': 'Record Meter Reading for another Meter',
            'description': 'You are welcome to record meter readings for meters that were not requested in this reading list. These additional readings are forwarded directly to <1>{{applicationName}}</1> after they have been recorded. Please note that these additionally recorded readings will no longer be displayed here after they have been forwarded.',
            'loginDropdown': {
                'optionFallback': 'no identifier',
                'placeholder': 'Please select'
            },
            'notAllowedNotification': {
                'title': 'Not allowed',
                'message': 'You do not have the required rights for this function.'
            },
        },
    },
    'evaluation': {
        'hint': 'Select a meter in the menu on the left to show its evaluation.',
        'labels': {
            'readingsNotDone': 'Not done',
            'readingsWithoutEvaluation': 'Not evaluable',
        },
        'details': {
            'title': 'Meter Evaluation',
            'labels': {
                'consumptions': 'Consumptions',
                'history': 'Reading History',
                'meterAddress': 'Meter Address',
                'consumption': 'Consumption',
                'comparisonToPreviousConsumption': 'Comparison with last Consumption',
            },
        },
        'empty': {
            'noJobs': 'Insufficient data available. The evaluation is currently not possible.',
            'noReadingEventsForMeterRate': 'No meter reading results are available for the rate {{rateName}}.',
            'noReadingEventsForMeterRates': 'No meter reading results are available for the rates {{rateNames}}.',
            'noEvaluationPossibleWithRateName': 'No consumption evaluation can be performed for rate: {{rateName}}.',
            'noEvaluationPossibleNoRateName': 'No consumption evaluation can be performed for this rate.',
        },
    },
    'management': {
        'hint': 'Select an account in the menu on the left to share jobs.',
        'excelExport': {
            'selection': {
                'description': 'Please select the jobs you want to download.',
                'notice': {
                    'label': 'Hint:',
                    'text': 'A separate Excel file is downloaded for each selected group.',
                },
            },
            'wizard': {
                'button': 'Download jobs',
                'title': 'Download jobs',
                'defaultGroupName': 'Jobs',
                'steps': {
                    'selectJobs': 'Select jobs',
                    'chooseFormat': 'Choose format',
                },
                'actions': {
                    'cancel': 'Cancel',
                    'next': 'Next',
                    'back': 'Back',
                    'export': 'Download jobs',
                    'retry': 'Try again',
                    'loading': 'File is being created...',
                },
                'loadingOverlay': 'File is being created...',
                'showExpiredJobs': 'Show expired jobs',
                'showDoneJobs': 'Show completed jobs',
                'errors': {
                    'exportFailed': 'Download failed. Please try again.',
                },
                'info': {
                    'autoFormat': 'Recommended for most cases: we automatically include only the columns that differ between your selected jobs. Details that are the same across all jobs are left out – keeping the file clear. No further setup required.',
                },
                'format': {
                    'groupLabel': 'Excel format',
                    'auto': 'Automatic',
                    'moreFormats': 'More formats',
                    'custom': 'Custom',
                    'customHint': 'For full control: the key reading data is always included. Beyond that, you decide which additional information (e.g. customer, meter and job data) is added – ideal for tailoring the file to a specific recipient.',
                },
            },
            'file': {
                'sheetName': 'Reading list',
                'status': {
                    'incomplete': 'Data incomplete',
                    'done': 'Reading complete',
                    'invalid': 'Invalid data',
                    'implausible': 'Meter reading implausible',
                    'alreadyRead': 'Already read',
                },
            },
            'columns': {
                'groups': {
                    'meter': 'Meter',
                    'reading': 'Reading',
                    'location': 'Metering point',
                    'customer': 'Customer',
                    'partner': 'Partner',
                    'tariff': 'Job',
                    'history': 'Readings',
                },
                'fields': {
                    'meterNumber': '$t(meterReadingJob.meterNumber)',
                    'obis': '$t(meterReadingJob.obisCode)',
                    'readingDate': '$t(meterReadingJob.readingDate)',
                    'readingValue': '$t(meterReadingJob.readingValue)',
                    'readingHint': '$t(meterReadingJob.address.hint)',
                    'status': '$t(meterReadingJob.status)',
                    'meterAddressStreet': '$t(meterReadingJob.address.street) and $t(meterReadingJob.address.houseNumber)',
                    'meterAddressZip': '$t(meterReadingJob.address.zip)',
                    'meterAddressCity': '$t(meterReadingJob.address.city) / $t(meterReadingJob.address.cityDistrict)',
                    'meterAddressObjectKey': '$t(meterReadingJob.objectKey)',
                    'meterAddressLocationDescription': '$t(meterReadingJob.address.locationDescription)',
                    'meterAddressLocationHint': 'Hint',
                    'customerNumber': '$t(meterReadingJob.customer.customernumber)',
                    'customerName': '$t(meterReadingJob.customer.name)',
                    'customerCompany': '$t(meterReadingJob.customer.company)',
                    'mailingAddressStreet': 'Street and house number',
                    'mailingAddressZip': 'Postal code',
                    'mailingAddressCity': 'City',
                    'mailingAddressPostbox': 'Postbox',
                    'email': 'Email',
                    'phone': 'Phone',
                    'mobile': 'Mobile',
                    'partnerKey': '$t(meterReadingJob.partner.identifier)',
                    'partnerName': '$t(meterReadingJob.partner.name)',
                    'partnerCompany': '$t(meterReadingJob.partner.company)',
                    'partnerContractId': 'Contract ID',
                    'tariffName': 'Tariff name',
                    'unit': 'Unit',
                    'meterType': '$t(meterReadingJob.meterType)',
                    'maLoId': '$t(meterReadingJob.maLoId)',
                    'meloId': '$t(meterReadingJob.meLoId)',
                    'externalOrderId': 'External order ID',
                    'validUntil': 'Valid until',
                    'executionDeadline': '$t(meterReadingJob.jobConstraints.latestExecution)',
                    'targetReadingDate': '$t(common.targetReadingDate)',
                    'lastReadingValue': 'Last reading value',
                    'lastReadingDate': 'Last reading date',
                    'lastResultValue': 'Last submitted value',
                    'lastResultDate': 'Submitted on',
                },
                'excelFields': {
                    'customerNumber': 'Customer: $t(meterReadingJob.customer.customernumber)',
                    'customerName': 'Customer: $t(meterReadingJob.customer.name)',
                    'customerCompany': 'Customer: $t(meterReadingJob.customer.company)',
                    'customerPostalAddress': 'Customer: Address',
                    'customerMailingAddressStreet': 'Customer: Street and house number',
                    'customerMailingAddressZip': 'Customer: Postal code',
                    'customerMailingAddressCity': 'Customer: City',
                    'customerMailingAddressPostbox': 'Customer: Postbox',
                    'customerContactEmail': 'Customer: Email',
                    'customerContactPhone': 'Customer: Phone',
                    'customerContactMobile': 'Customer: Mobile',
                    'partnerKey': '$t(meterReadingJob.partner.identifier)',
                    'partnerName': 'Partner: $t(meterReadingJob.partner.name)',
                    'partnerCompany': '$t(meterReadingJob.partner.company)',
                    'partnerContractId': 'Partner: Contract ID',
                    'partnerMailingAddressStreet': 'Partner: Street and house number',
                    'partnerMailingAddressZip': 'Partner: Postal code',
                    'partnerMailingAddressCity': 'Partner: City',
                    'partnerMailingAddressPostbox': 'Partner: Postbox',
                    'partnerContactEmail': 'Partner: Email',
                    'partnerContactPhone': 'Partner: Phone',
                    'partnerContactMobile': 'Partner: Mobile',
                    'meterAddressStreet': 'Metering point: $t(meterReadingJob.address.street) and $t(meterReadingJob.address.houseNumber)',
                    'meterAddressZip': 'Metering point: $t(meterReadingJob.address.zip)',
                    'meterAddressCity': 'Metering point: $t(meterReadingJob.address.city) / $t(meterReadingJob.address.cityDistrict)',
                    'meterAddressObjectKey': 'Metering point: $t(meterReadingJob.objectKey)',
                    'meterAddressLocationDescription': 'Metering point: $t(meterReadingJob.address.locationDescription)',
                    'meterAddressLocationHint': 'Metering point: Hint',
                    'externalOrderId': 'External order ID',
                    'maLoId': '$t(meterReadingJob.maLoId)',
                    'meloId': '$t(meterReadingJob.meLoId)',
                    'meterType': '$t(meterReadingJob.meterType)',
                    'tariffName': 'Tariff name',
                    'unit': 'Unit',
                    'executionDeadline': '$t(meterReadingJob.jobConstraints.latestExecution)',
                    'validUntil': 'Valid until',
                    'lastReadingDate': 'Last reading date',
                    'lastReadingValue': 'Last reading value',
                    'lastResultDate': 'Submitted on',
                    'lastResultValue': 'Last submitted value',
                },
                'aria': {
                    'selectGroup': 'Select all columns from "{{group}}"',
                    'collapseGroup': 'Collapse group',
                    'expandGroup': 'Expand group',
                },
            },
        },
        'accounts': {
            'title': 'My Accounts',
            'reminder': {
                'subject': 'Meter Reading Reminder',
                'body': 'Dear {{name}},\n\n\nwe would like to remind you to enter your meter readings in the Meter Reading Portal.\n\nTo access your Meter Reading Portal, please click on the following link:\n\n{{login}}\n'
            },
            'labels': {
                'total': 'total',
            },
            'list': {
                'by': 'by',
            },
            'subaccounts': {
                'empty': 'You have not yet shared accounts.',
                'buttons': {
                    'share': 'Share Jobs',
                    'shareShort': 'Share'
                },
                'overview': {
                    'title': 'Created accounts',
                },
                'details': {
                    'openedByToken': 'This share was created by yourself. Here you can see the meters that are included in it.',
                    'description': 'This account contains {{count}} meter reading job',
                    'description_other': 'This account contains {{count}}  meter reading jobs',
                    'delete': {
                        'confirm': {
                            'title': 'Delete account?',
                            'description': 'The account will be deleted, meter reading jobs and results will remain.',
                        },
                        'title': 'Remove meter reading from this account?',
                        'description': 'The meter reading job will be removed <1>from this Account</1>. It will remain in your meter reading jobs.',
                    },
                    'reshare': {
                        'title': 'Create new Access',
                        'description': 'Do you want to add a login? The current login will remain.',
                    },
                },
            },
            'share': {
                'quickShareInfo': {
                    'intro': 'Sharing directly immediately creates this access and sends the emails:',
                    'accessName': 'Access name:',
                    'nameFallback': '(no name)',
                    'reshareLabel': 'Resharing:',
                    'reshareYes': 'allowed',
                    'reshareNo': 'not allowed',
                    'emailsLabel': 'Emails to:',
                    'noEmails': 'none saved',
                    'moreEmails': '+{{count}} more',
                },
                'assignmentPresets': {
                    'label': 'Saved preset:',
                    'meterChanged': 'Meter number differs – possible meter change',
                    'meterChangedLabel': 'different meter',
                    'meterChangedTitle': 'Meter number differs',
                    'meterChangedTooltipIntro': 'A different meter number is currently registered for the measurement Location {{meLoId}} than when the preset was created.',
                    'meterChangedStoredLabel': 'Stored then',
                    'meterChangedCurrentLabel': 'Now',
                    'meterChangedNotice': 'One of the selected jobs has a different meter than the one stored when the preset was created.',
                    'meterChangedNotice_other': '{{count}} of the selected jobs have a different meter than the one stored when the preset was created.',
                    'deleteConfirm': 'Really delete the saved preset "{{name}}"?',
                    'deleteLabel': 'Delete saved preset',
                    'selectPlaceholder': 'Select preset',
                    'resetLabel': 'Reset preset',
                    'deleteConfirmOk': 'Delete',
                },
                'title': 'Share Jobs',
                'task': 'job',
                'task_other': 'jobs',
                'buttons': {
                    'share': 'Share {{count}} Job',
                    'share_other': 'Share {{count}} Jobs',
                    'shareStepByStep': 'Share step by step',
                    'quickShare': 'Share {{count}} job directly & send emails',
                    'quickShare_other': 'Share {{count}} jobs directly & send emails',
                    'quickShareNoEmails': 'No emails saved in the preset',
                },
                'error': {
                    'maxjobs': 'A maximum of {{count}} jobs can be shared.'
                },
                'loading': 'loading jobs...',
                'labels': {
                    // 'status',
                },
                'empty': 'You don\'t have any jobs to share',
                'description': 'Please select the jobs you want to share.',
                'hint': '<0>Hint:</0> Click on the column names to sort the table. With a click on <3/> you can group by a column.',
                'hintSortOnly': '<0>Hint:</0> Click on the column names to sort the table.',
                'tableColumns': {
                    'isShared': 'Shared',
                    'allHidden': 'All columns are hidden for this table.',
                },
                'exportXlsx': {
                    'title': 'Download readings as an Excel file',
                    'description': 'If necessary, you can download the selected reading jobs as an Excel file.',
                    'label': 'Download file',
                    'button': 'Excel file download',
                    'headers': {
                        'partnerIdentifier': '$t(meterReadingJob.partner.identifier)',
                        'partnerCompany': '$t(meterReadingJob.partner.company)',
                        'customerNumber': '$t(meterReadingJob.customer.customernumber)',
                        'customerCompany': '$t(meterReadingJob.customer.company) BP',
                        'customerMailingAddressStreet': '$t(meterReadingJob.address.street) BP',
                        'customerMailingAddressHouseNumber': '$t(meterReadingJob.address.houseNumber) BP',
                        'customerMailingAddressZip': '$t(meterReadingJob.address.zip) BP',
                        'customerMailingAddressCity': '$t(meterReadingJob.address.city) BP',
                        'maLoId': '$t(meterReadingJob.maLoId)',
                        'meterAddressStreet': 'Consumption Point $t(meterReadingJob.address.street)',
                        'meterAddressHouseNumber': 'Consumption Point $t(meterReadingJob.address.houseNumber)',
                        'meterAddressZip': 'Consumption Point $t(meterReadingJob.address.zip)',
                        'meterAddressCity': 'Consumption Point $t(meterReadingJob.address.city)',
                        'meterAddressObjectKey': 'Consumption Point $t(meterReadingJob.objectKey)',
                        'meterAddressLocationDescription': 'Consumption Point $t(meterReadingJob.address.locationDescription)',
                        'meterAddressHint': '$t(meterReadingJob.address.hint)',
                        'lastMeterReadingDate': 'last Reading Date',
                        'lastMeterReadingValue': 'last Reading Value',
                        'meterReadingDate': '$t(meterReadingJob.readingDate)',
                        'meterReadingValue': '$t(meterReadingJob.readingValue)',
                        'meterNumber': '$t(meterReadingJob.meterNumber)',
                        'meterType': '$t(meterReadingJob.meterType)',
                        'rateName': '$t(meterReadingJob.rates)',
                        'obis': '$t(meterReadingJob.obisCode)',
                        'targetReadingDate': '$t(common.targetReadingDate)',
                        'latestExecution': '$t(meterReadingJob.jobConstraints.latestExecution)',
                    },
                    'error' : {
                        'title': 'Excel download error',
                        'message': 'An error occurred while downloading Excel data. Please try again later.'
                    }
                },
            },
        },
            'import': {
                'button': 'Submit meter readings',
                'wizardSteps': {
                    'fileSelect': 'Choose file',
                    'review': 'Review meter readings',
                    'summary': 'Summary',
                },
                'fileSelect': {
                    'title': 'Submit meter readings',
                    'dropzone': 'Drop or choose file here',
                    'button': 'Choose file',
                    'error': 'The file could not be read',
                    'formatHint': 'Only .xlsx files are supported',
                    'analyzing': 'Analyzing file...',
                    'noJobsError': 'No jobs loaded. Please reload the page.',
                },
                'plausible': {
                    'body': '{{count}} new plausible meter reading was detected.',
                    'body_other': '{{count}} new plausible meter readings were detected.',
                    'otherSkipped': '{{count}} additional meter reading will be handled in the next steps.',
                    'otherSkipped_other': '{{count}} additional meter readings will be handled in the next steps.',
                },
                'warning': {
                    'title': 'Implausible meter readings',
                    'body': '{{count}} implausible meter reading was detected. Do you want to submit it without review? (not recommended)',
                    'body_other': '{{count}} implausible meter readings were detected. Do you want to submit them without review? (not recommended)',
                },
                'review': {
                    'progress': 'Review meter reading {{current}} of {{total}}',
                    'tariffLabel': 'Tariff',
                    'readingDateLabel': 'Reading date',
                    'readingValueLabel': 'Reading value',
                    'commentLabel': 'Reading hint',
                    'photoLabel': 'Add reading photo',
                    'alreadyDoneHint': 'Already submitted – will not be sent again.',
                    'noValueHint': 'Not filled in – stays open and can be read later.',
                    'plausibleHint': 'Plausible reading value',
                    'plausibleOnlyConfirm': {
                        'title': 'Submit only the plausible meter readings?',
                        'content': 'Implausible meter readings will not be submitted.',
                        'confirm': 'Submit plausible only & continue',
                    },
                    'skipAllHint': 'Do not send all: The currently displayed meter reading and all following meter readings still to be reviewed will not be submitted. Already submitted meter readings remain unchanged.',
                },
                'summary': {
                    'resultTitle': 'New meter reading successfully submitted',
                    'resultTitle_other': 'New meter readings successfully submitted',
                    'resultTitleAllDone': 'Meter reading successfully submitted',
                    'resultTitleAllDone_other': 'All meter readings successfully submitted',
                    'resultTitleNone': 'No new meter readings submitted',
                    'reDownloadHint': 'For the meter readings that were not submitted, you can download the affected jobs again and, if needed, submit the values again afterwards.',
                    'submittedPlausible': 'Automatically recognized as plausible and submitted',
                    'submittedImplausible': 'Released after manual review and submitted',
                    'notImportedSummary': 'Not submitted – e.g. deliberately skipped or due to an issue in the data.',
                    'reason': {
                        'alreadyDone': 'Already submitted – not sent again',
                    },
                    'skippedFiles': '{{count}} file not processed (not .xlsx)',
                    'skippedFiles_other': '{{count}} files not processed (not .xlsx)',
                    'reExportButton': 'Download jobs again',
                    'reExportFileSuffix': 'Review',
                    'reExportError': {
                        'title': 'Download again failed',
                        'message': 'The file could not be created. Please try again.',
                    },
                },
                'actions': {
                    'import': 'Send & continue',
                    'skip': 'Do not send & continue',
                    'skipAll': 'Do not send all',
                    'cancel': 'Cancel',
                    'importAll': 'Send all without review & continue',
                    'review': 'Review meter readings',
                    'close': 'Close',
                    'importMore': 'Import another file',
                },
            },
    },
    'help': {
        'global': {
            'contentTitle': 'Meter Reading Portal - Help',
            'tableOfContents': 'Table of Contents',
            'defaultText': 'Help is not available in the selected language.',
            'offlineText': 'Help is not available offline.',
            'errorText': 'Help is currently unavailable.',
            'backToTop': 'Back to top',
        },
        'sidePopOver': {
            'title': 'Reading help',
            'button': 'Help',
        },
    },
    'communication': {
        'triggerButton': {
            'registration': 'Sign Up Here',
            'communication': 'Send reading confirmation',
        },
        'home': {
            'title': 'Digital & Paperless Communication',
            'registration': {
                'description': 'Switch to digital communication. It protects the environment and saves time. It is also faster and you keep track of everything.',
                'descriptionBulletPointsTitle': 'Your benefits:',
                'descriptionBulletPoints': [
                    'Confirmation of the successful reading by email',
                    'Compilation of all information about your reading',
                    'Fast and uncomplicated notifications via email in the future',
                ],
            },
            'communication': {
                'description': 'You are registered for digital communication and can request the reading confirmation via email.',
            }
        },
        'jobDetails': {
            'title': 'Digital Communication',
            'registration': {
                'description': 'Switch to digital communication. It protects the environment and saves time. It is also faster and you keep track of everything.',
            },
            'communication': {
                'description': 'You are registered for digital communication and can request the reading confirmation via email.',
            }
        },
        'dialog': {
            'registration': {
                'title': 'Sign Up for Digital & Paperless Communication',
                'description': 'To receive the reading confirmation via email, please sign up for digital communication.',
                'content': 'Receive your reading confirmations conveniently via email. You can adjust your communication settings at any time if needed.',
                'missingURL': 'Signing up for digital communication is currently not possible. Please try again later.',
                'submitButtonText': 'Register',
                'cancelButtonText': 'Cancel',
            },
            'communication': {
                'title': 'Receive reading confirmation by email',
                'description': 'You are already signed up for digital communication. You can request the reading confirmations via email here.',
                'content': 'Sending the reading confirmation by email is free of charge for you. You have read one meter. Would you like to request a reading confirmation by email?',
                'content_other': 'Sending the reading confirmation by email is free of charge for you. You have already read {{count}} meters. Would you like to request a reading confirmation by email?',
                'submitButtonText': 'Request reading confirmation',
                'cancelButtonText': 'Cancel',
            }
        },
        'notification': {
            'registration': {
                'done': {
                    'title': 'Successfully signed up for digital communication',
                    'description': 'From now on, you can receive a reading confirmation by email after you have completed a meter reading.'
                }
            },
            'communication': {
                'done': {
                    'title': 'Confirmation on its way',
                    'description': 'We have sent you the confirmation of your reading by email.',
                    'description_other': 'We have sent you the confirmation of your {{count}} readings by email.',
                },
                'error': {
                    'title': 'Request for reading confirmation failed',
                    'description': 'The reading confirmation by email for one meter could not be sent. Please try again later.',
                    'description_other': 'The reading confirmation by email for {{count}} meters could not be sent. Please try again later.',
                }
            }
        }
    },
    'meterReadingJob': {
        'type': 'Type',
        'status': 'Status',
        'meter': 'Meter',
        'meLoId': 'Measurement Location',
        'maLoId': 'Market Location',
        'meterNumber': 'Meter Number',
        'meterType': 'Meter Type',
        'rates': 'Rate',
        'obisCode': 'OBIS',
        'objectKey': 'Object',
        'readingDate': 'Reading Date',
        'readingValue': 'Reading Value',
        'jobConstraints': {
            'earliestExecution': 'Earliest Execution',
            'latestExecution': 'Latest Execution',
        },
        'partner': {
            'title': 'partner',
            'identifier': 'Partner-No.',
            'company': 'Partner-Company',
            'name': 'Name',
            'firstname': 'Partner-Firstname',
            'lastname': 'Partner-Lastname',
        },
        'customer': {
            'title': 'Customer',
            'customernumber': 'Customernumber',
            'company': 'Company',
            'name': 'Name',
            'summary': 'Customer, combined',
            'firstname': 'Firstname',
            'lastname': 'Lastname',
        },
        'address': {
            'title': 'Address',
            'fullAddress': 'Meter Address',
            'name': 'Address name',
            'company': 'Address company',
            'firstname': 'Address first name',
            'lastname': 'Address last name',
            'street': 'Street',
            'houseNumber': 'House Number',
            'zip': 'ZIP',
            'city': 'City',
            'cityDistrict': 'City-District',
            'hint': 'Reading Hint',
            'locationDescription': 'Location',
        },
        'aggregation': {
            'street': '{{count}} street',
            'street_other': '{{count}} streets',
            'zip': '{{count}} zip',
            'zip_other': '{{count}} zips',
            'city': '{{count}} city',
            'city_other': '{{count}} cities',
            'cityDistrict': '{{count}} city-district',
            'cityDistrict_other': '{{count}} city-districts',
            'customernumber': '{{count}} Cust.No.',
            'customernumber_other': '{{count}} Cust.No.',
            'objectKey': '{{count}} object',
            'objectKey_other': '{{count}} objects',
            'meter': '{{count}} meter',
            'meter_other': '{{count}} meters',
            'latestExecution': '{{count}} expiration date',
            'latestExecution_other': '{{count}} expiration dates',
        },
    },
    'offline': {
        'warning': 'Please don\'t close the browser!',
        'description' : 'We can\'t send your readings. They will be transmitted, as soon as the device has an internet connection.',
        'details': 'You can proceed with further meter readings. The readings will be queued and transmitted automatically, as soon as there is a stable internet connection.',
        'infopanel' : {
            'message' : '{{queueLength}} meter reading is queued',
            'message_other' : '{{queueLength}} meter readings are queued',
            'messageOnline' : '{{queueLength}} meter reading is still being sent',
            'messageOnline_other' : '{{queueLength}} meter readings are still being sent',
            'messageMobile' : 'You are offline. {{queueLength}} meter reading not yet sent.',
            'messageMobile_other' : 'You are offline. {{queueLength}} meter readings not yet sent.',
            'messageMobileOnline' : '{{queueLength}} meter reading is still being sent',
            'messageMobileOnline_other' : '{{queueLength}} meter readings are still being sent',
            'details' : 'They will be sent, if you are online again.'
        },
        'buttons' : {
            'close': 'Hide hint',
            'retry': 'Retry'
        }
    },
    'menu': {
        'home': 'Home',
        'reading': 'My Meters',
        'evaluation': 'Evaluation',
        'management': 'Management',
        'help': 'Help',
        'accounts': 'My Accounts',
        'logout': 'Logout',
    },
    'common': {
        'close': 'Close',
        'metertypes': {
            'ELECTRIC_METER': 'Electric Meter',
            'HEAT_METER': 'Heat Meter',
            'GAS_METER': 'Gas Meter',
            'WATER_METER': 'Water Meter',
            'WATER_WARM_METER': 'Warm Water Meter',
            'GENERIC_METER': 'Meter',
        },
        'reasons': {
            'INITIAL_READING': 'Initial Reading',
            'PERIODIC_READING': 'Periodic Reading',
            'ESTIMATED_READING': 'Estimated Reading',
            'INTERMEDIATE_READING': 'Intermediate Reading',
            'METER_CHANGE': 'Meter Change',
            'OTHER': 'Other Reading',
            'OTHER_KSA': 'Customer Reading',
            'null': 'Unknown Reason'
        },
        'jobs': '{{count}} job',
        'jobs_other': '{{count}} jobs',
        'reading': 'meter reading',
        'reading_other': 'meter readings',
        'progress': 'progress',
        'targetReadingDate': 'target reading date',
        'loadingReadings': 'loading meter readings...',
        'loadingJobs': 'loading jobs...',
        'search': 'Search',
        'total': 'total',
        'until': 'until',
        'of': 'of',
        'loading': 'loading...',
        'imprint': 'Imprint',
        'dataPrivacy': 'Data Privacy Terms',
        'dialog': {
            'ok': 'OK',
            'abort': 'Abort',
        },
        'requiredField': 'Required Field',
        'fillRequiredFields': 'Please fill in required fields (*).',
        'account': {
            'noName': 'My Account',
        },
        'day': 'Day',
        'highContrastOn': 'High Contrast on',
        'highContrastOff': 'High Contrast off',
        'changeLanguageTo': 'Change Language to {{language}}',
        'selectReadingDate': 'Select reading date',
        'grouping': {
            'emptyValue': 'Not specified',
        },
    },
    'ai': {
        'cameraDialogDetails': {
            'loading': 'processing...',
            'hint': 'Please place your meter inside the frame.',
        },
        'readingValueDetectedDialogDetails': {
            'hint': 'Is the displayed meter reading correct?',
            'imageLabel': 'Meter Reading detected'
        },
        'meterRateDetectedDialogDetails': {
            'hint': 'Please enter your meter reading.',
            'imageLabel': 'Display detected',
        },
        'noResultDialogDetails': {
            'hint': 'Can the meter reading and meter number be recognized in the photo?',
            'imageLabel': 'Preview'
        },
        'invalidMediumOutcome': {
            'title': 'Wrong meter?',
            'description': 'Please check if you photographed the correct meter.',
            'expectedLabel': 'Expected meter type:',
            'detectedLabel': 'Meter type from photo:',
        },
        'invalidMeterNumberOutcome': {
            'title': 'Wrong meter?',
            'description': 'Please check if you photographed the correct meter.',
            'expectedLabel': 'Expected meter number:',
            'detectedLabel': 'Meter number from photo:',
        },
        'invalidObisOutcome': {
            'title': 'Wrong tariff?',
            'description': 'Please check if you photographed the correct tariff.',
            'expectedLabel': 'Expected tariff:',
            'detectedLabel': 'Tariff from photo:',
        },
        'gallery': {
            'noResultDialogDetails': {
                'hint': 'Can the meter reading and meter number be recognized in the selected photo?',
                'imageLabel': 'Preview'
            },
            'invalidMediumOutcome': {
                'title': 'Wrong meter?',
                'description': 'Please check whether you selected the correct photo.',
                'expectedLabel': 'Expected meter type:',
                'detectedLabel': 'Meter type from photo:',
            },
            'invalidMeterNumberOutcome': {
                'title': 'Wrong meter?',
                'description': 'Please check whether you selected the correct photo.',
                'expectedLabel': 'Expected meter number:',
                'detectedLabel': 'Meter number from photo:',
            },
            'invalidObisOutcome': {
                'title': 'Wrong tariff?',
                'description': 'Please check whether you selected the correct photo.',
                'expectedLabel': 'Expected tariff:',
                'detectedLabel': 'Tariff from photo:',
            },
            'buttons': {
                'retakeImage': 'Choose another photo',
                'takeImage': 'Use photo',
            },
        },
        'noPermissionDialog': {
            'title': 'Camera access blocked',
            'description': 'Please allow camera access in your browser\'s site settings to enable all features and try again.',
            'iosHint': 'On your iPhone or iPad, open Settings → Apps → [your browser] → Camera and set it to “Allow”.',
            'androidHint': 'On your Android device, open the browser menu (⋮) → Site settings → Camera and set the permission to “Allow”.',
            'hint': 'Alternatively, you can choose a photo from your gallery.',
            'confirmButtonText': 'Continue without access',
            'cancelButtonText': 'Cancel'
        },
        'buttons': {
            'confirm': 'Confirm',
            'cancel': 'Cancel',
            'retakeImage': 'Retake photo',
            'takeImage': 'Accept photo',
            'forceObis': 'Use for {{obis}}'
        },
        'common': {
            'readingValue': 'Meter Reading',
            'title': 'Reading Photo'
        }
    },
    'aiReading': {
        'title': 'Reading assistant',
        'stepIndicator': 'Step {{step}} of {{total}}',
        'degradedHint': 'Simplified view active – detection keeps running.',
        'alignment': {
            'noMeter': 'Point the camera at your meter',
            'moveLeft': 'Move the camera slightly left',
            'moveRight': 'Move the camera slightly right',
            'moveUp': 'Move the camera slightly up',
            'moveDown': 'Move the camera slightly down',
            'moveCloser': 'Move closer',
            'moveBack': 'Move back a little',
            'holdStill': 'Perfect – hold still!',
        },
        'progress': {
            'registers': '{{captured}} of {{total}} readings captured',
        },
        'overlay': {
            'checking': 'verifying…',
        },
        'medium': {
            'ELECTRICITY': 'electricity meter',
            'GAS': 'gas meter',
            'WATER': 'water meter',
            'WATER_WARM': 'warm water meter',
            'HEAT': 'heat meter',
            'ABSTRACT': 'meter',
        },
        'instructions': {
            'consent': 'For the guided reading, your camera image is sent to our server for detection. Only images of your meter are processed.',
            'cameraPermission': 'Please allow access to your camera.',
            'permissionDenied': 'Camera access is not possible. You can enter the meter reading manually.',
            'framing': 'Point the camera at your meter.',
            'identify': 'Place the meter inside the bright frame and hold the camera steady.',
            'candidates': 'Several meter numbers were detected. Please select your meter.',
            'noMatch': 'The meter could not be matched to any of your reading jobs.',
            'noMatchWrongMedium': 'A {{medium}} was detected – there is no reading job for it in your account.',
            'noMatchNumber': 'The meter number {{number}} does not match any of your reading jobs. Are you perhaps standing at a different meter?',
            'noMatchNumberSpoken': 'The detected meter number does not match any of your reading jobs. Are you perhaps standing at a different meter?',
            'tariffs': 'The meter reading is being captured. Please hold the camera steady.',
            'tariffs_other': 'The meter readings are being captured. Please hold the camera steady.',
            'read': 'Hold the camera steady on the register.',
            'confirm': 'Please check and confirm the detected meter reading.',
            'confirm_other': 'Please check and confirm the detected meter readings.',
            'done': 'Thank you! Your reading has been submitted.',
            'offline': 'No internet connection. The assistant needs an active internet connection to read your meter.',
            'framingTimeout': 'No meter was detected. Please point the camera directly at the meter and make sure there is enough light.',
        },
        'feedback': {
            'meterMatched': 'Meter identified!',
            'multipleRegisters': 'This meter has {{total}} tariffs.',
            'registerCaptured': 'Value {{captured}} of {{total}} captured – please keep holding still.',
            'allValuesCaptured': 'All values captured.',
        },
        'stuck': {
            'title': 'Reading incomplete',
            'description': 'Some values cannot be recognized reliably right now. You can continue manually inside the job.',
        },
        'framingTimeout': {
            'title': 'No meter found',
        },
        'offline': {
            'title': 'No internet connection',
            'description': 'The assistant needs an active internet connection to read your meter. Please check your connection and try again.',
        },
        'buttons': {
            'start': 'Start reading assistant',
            'startAssistant': 'Start reading assistant',
            'mute': 'Turn off sound',
            'unmute': 'Turn on sound',
            'confirmAll': 'Confirm meter reading',
            'confirmAll_other': 'Confirm meter readings',
            'retry': 'Try again',
            'nextMeter': 'Capture another meter',
            'manualCapture': 'Capture manually',
            'continueInJob': 'Continue in the job',
            'keepTrying': 'Keep trying',
            'exit': 'Close assistant',
            'manualEntry': 'Enter manually',
            'close': 'Close',
            'next': 'Next',
            'back': 'Back',
        },
        'consent': {
            'title': 'Start reading assistant',
            'privacyHint': 'You can find information on data protection in our privacy policy.',
            'audioLabel': 'Read instructions aloud',
        },
        'done': {
            'title': 'Reading submitted',
            'moreOpen': 'You still have open readings.',
            'allDone': 'All your readings are done!',
        },
        'notFound': {
            'title': 'Meter not recognized',
            'titleWrongMedium': 'Wrong meter type?',
            'titleNumberMismatch': 'Meter number does not match',
        },
        'candidates': {
            'title': 'Which meter number is yours?',
        },
        'confirmPanel': {
            'title': 'Detected meter reading',
            'title_other': 'Detected meter readings',
            'stepIndicator': 'Rate {{index}} of {{total}}',
            'unconfirmed': 'This value was only detected once. Please double-check it.',
        },
    },
};
